export function timesheetAttachment(action, key, value) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('jm-rh-attachments', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('files');
    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      const db = request.result;
      const tx = db.transaction('files', action === 'get' ? 'readonly' : 'readwrite');
      const store = tx.objectStore('files');
      const operation = action === 'get' ? store.get(key) : action === 'delete' ? store.delete(key) : store.put(value, key);
      tx.oncomplete = () => { db.close(); resolve(operation.result); };
      tx.onerror = () => { db.close(); reject(tx.error); };
      tx.onabort = () => { db.close(); reject(tx.error || new Error('Enregistrement interrompu')); };
    };
  });
}
